import { useState } from "react";
import ContentLayout from "../../layout/contentLayout";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import { Grid, SelectChangeEvent,} from "@mui/material";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import StackKit from "@/shared/components/kit/stack";
import Content from "./content";
import CustomSelectNormal from "@/shared/components/common/select/selectNormal";
/**
 * WalletCreditBalanceReports
 *
 * نمایش گزارش موجودی اعتباری کیف پول با قابلیت انتخاب نوع موجودی.
 * این کامپوننت شامل عنوان، آیکون و فیلتر دسته‌بندی گزارش ها کیف پول اعتباری می‌باشد.
 *
 * ویژگی‌ها:
 * - استفاده از ContentLayout برای ساختار صفحه
 * - نمایش آیکون و عنوان صفحه
 * - فیلتر دسته‌بندی موجودی کیف پول اعتباری
 * - واکنش‌گرایی با StackKit و Grid برای چینش عناصر در اندازه‌های مختلف صفحه
 * - بارگذاری کامپوننت Content که گزارش تراکنش‌ها را نمایش می‌دهد
 *
 * @returns {JSX.Element} کامپوننت WalletCreditBalanceReports
 *
 * داخلی‌ها:
 * - useState برای نگهداری مقدار انتخاب شده در فیلتر و شماره انتخاب شده
 * - handleChange برای بروزرسانی مقدار فیلتر
 * - dataOptionSelect آرایه‌ای از گزینه‌های فیلتر موجودی کیف پول اعتباری
 */
const WalletCreditBalanceReports = () => {
  const [value, setValue] = useState("موجودی نقدی : 5,000,000 ریال");
  const [selectedNumber, setSelectedNumber] = useState("all");

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };
  
  const dataOptionSelect = [
    { label: "موجودی سررسید نشده", value: "all" },
    { value: "charge_merchant_wallet", label: "موجودی قابل برداشت" },
  ];
  return (
    <ContentLayout
      icon={<AccountBalanceWalletOutlinedIcon />}
      title="موجودی اعتباری کیف پول"
      detailTitle={
        <Grid size={12} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2, width:'100%'}}>
          <StackKit sx={{ width: "100%" }} direction={{sm:'row',xs:'column'}} justifyContent={{sm:'end',xs:'center'}} alignItems={"center"} gap={1}>
            <TypoGraphyKit textAlign={'center'} variant="body1">
              دسته بندی گزارش ها کیف پول اعتباری
            </TypoGraphyKit>
            <CustomSelectNormal label="" value={selectedNumber} onChange={(e, item) => {setSelectedNumber(e.target.value);}} options={dataOptionSelect ?? []} getOptionLabel={(item) => `${item.label}`} getOptionValue={(item) => item.value} width={"fit-content"}/>
          </StackKit>
        </Grid>
      }
      isContainerFluid
    >
      <Content selectedNumber={selectedNumber} />
    </ContentLayout>
  );
};

export default WalletCreditBalanceReports;
